export default __webpack_public_path__ + "static/media/higher_frame_hi_ident_reversed.84a746a1.svg";